import { memo } from 'react'
import { Wrapper, InnerWrapper } from './Styled'

export interface AreaWrapperProps {
  children?: React.ReactNode
  [key: string]: any
}

function AreaWrapper({ children, ...props }: AreaWrapperProps) {
  return (
    <Wrapper>
      <InnerWrapper {...props}>{children}</InnerWrapper>
    </Wrapper>
  )
}

export default memo(AreaWrapper)
